import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import styles from './TypeText.module.scss';

const cx = classNames.bind(styles);

const TypeText = forwardRef(({ className, onKeyDown, ...props }, ref) => {
  const handleKeyDown = (e) => {
    if (e.nativeEvent.isComposing) return;

    if (e.code === 'Enter') {
      e.target.blur();
    }

    onKeyDown?.(e);
  };

  return <input ref={ref} type="text" {...props} onKeyDown={handleKeyDown} className={cx(['container', className])} />;
});

TypeText.displayName = 'TypeText';

TypeText.propTypes = {
  className: PropTypes.string,
  onKeyDown: PropTypes.func,
};

export default TypeText;
